<button type="button" (click)="notifyOfCommentClicked()" class="btn btn-secondary" [disabled]="isDisabled()">
    <i class="fas fa-comments me-1"></i>Notify of Comment
</button>
